import React from "react";

function Div(props) {
  return <div {...props}>{props.children}</div>;
}

export default Div;
